// https://www.figma.com/design/4nTOFTtmTmvTmhW9tfnXO7/Ankr-Design-System-2.0?node-id=9384-62751&m=dev
// MUI v5 color tokens mapped 1:1 to Ankr UI Palette tokens

import { createTheme } from '@mui/material/styles';
import {
  palette,
  darkPalette,
  lightPaletteBlockRail,
  darkPaletteBlockRail,
} from '@ankr.com/ui';

import { featureConfig } from 'modules/common/featureConfig';

const currentPaletteLight = featureConfig.isBlockrailTheme
  ? lightPaletteBlockRail
  : palette;

const lightPaletteLocal = {
  ...currentPaletteLight,

  text: {
    primary: currentPaletteLight.grey?.[900],
    secondary: currentPaletteLight.grey?.[700],
    disabled: currentPaletteLight.grey?.[400],
    primaryImmutable: currentPaletteLight.grey?.[900],
    positive: currentPaletteLight.success?.main,
    warning: currentPaletteLight.warning?.main,
    immutable: currentPaletteLight.common?.white,
  },

  divider: currentPaletteLight.grey?.[100],

  border: {
    secondary: currentPaletteLight.background?.default,
    warning: '#EEA841',
    focused: '#25272C80',
  },

  surface: {
    primary: currentPaletteLight.grey?.[100],
    tertiary: currentPaletteLight.grey?.[200],
    hover: currentPaletteLight.grey?.[200],
    overlay: currentPaletteLight.grey?.[800],

    brandLight: '#E1E8FD',

    error: '#D32547',
    warning: '#EEA841',
    success: '#3AC090',

    purple: '#AF52DE',

    successLight: '#E1F8E8',
    errorLight: '#FFE5E8',
    purpleLight: '#F3E5FA',
  },
};

const currentPaletteDark = featureConfig.isBlockrailTheme
  ? darkPaletteBlockRail
  : darkPalette;

const darkPaletteLocal = {
  ...currentPaletteDark,

  text: {
    primary: '#fff',
    secondary: '#A2A8B6',
    disabled: 'rgba(167,175,192,0.7)',
    primaryImmutable: '#1F2226',
    positive: '#48C398',
    warning: '#F0B358',
    immutable: '#FFFFFF',
  },

  // background: {
  //   default: '#1F2226',
  //   paper: '#2E343C',
  // },

  divider: '#42464F',

  border: {
    secondary: '#1F2226',
    warning: '#F0B358',
    focused: '#5AB7F280',
  },

  surface: {
    primary: '#1F2226',
    tertiary: '#42464F',
    hover: '#535863',
    overlay: '#585E6B',

    brandLight: '#E1E8FD',

    error: '#EC5478',
    warning: '#F0B358',
    success: '#48C398',

    purple: '#B967E2',

    successLight: '#0f3224',
    errorLight: '#350C15',
    purpleLight: '#23092F',
  },
};

const buildTheme = (mode: 'light' | 'dark' = 'light') =>
  createTheme({
    palette: mode === 'light' ? lightPaletteLocal : darkPaletteLocal,
  });

export const lightTheme = buildTheme('light');
export const darkTheme = buildTheme('dark');
